export const statusTypeOptions = [
  {
    value: 'CREATED',
    label: '已下架'
  },
  {
    value: 'NOT_START',
    label: '未开始'
  },
  {
    value: 'ONGOING',
    label: '进行中'
  },
  {
    value: 'ENDED',
    label: '已结束'
  },
]

export const activityStatus = {
  CREATED: 'CREATED',
  NOT_START: 'NOT_START',
  ONGOING: 'ONGOING',
  ENDED: 'ENDED',
}

export const checkInTypeOptions = [
  {
    label: '点击签到按钮直接签到',
    value: 1,
    disabled: true,
  },
  {
    label: '用户扫描现场签到二维码',
    value: 2,
    disabled: false,
  },
  {
    label: '工作人员扫描用户的二维码',
    value: 3,
    disabled: true,
  },
  {
    label: '无需签到',
    value: 4,
    disabled: true,
  }
]

export const approveStatusOptions = [{
  label: '审核未通过',
  value: 'REJECTED'
}, {
  label: '审核通过',
  value: 'APPROVED'
}]

export const pendingStatusOptions = [{
  label: '报名待审核',
  value: 'PENDING'
}, {
  label: '排队中',
  value: 'QUEUING'
}, {
  label: '排队失败',
  value: 'QUEUE_FAILURE'
}]

export const employeeApplyStatusTypeOptions = [
  {
    value: 'QUEUING',
    label: '排队中'
  },
  {
    value: 'QUEUE_FAILURE',
    label: '排队失败'
  },
  {
    value: 'APPROVED',
    label: '报名成功'
  },
  {
    value: 'REJECTED',
    label: '报名失败'
  }
]

export const organizedByOptions = [
  { value: 'Technical', label: '技术部' },
  { value: 'Talent Casting', label: '演员招聘部' },
  { value: 'Costuming', label: '服装部' },
  { value: 'C&P', label: '创意与制作部' },
  { value: 'ENT', label: '娱乐演出' },
  { value: 'Character', label: '迪士尼朋友团队' },
  { value: 'Atmo', label: '氛围演出团队' },
  { value: 'Parade', label: '巡游演出团队' },
  { value: 'EGP', label: '冰雪奇缘演出团队' },
  { value: 'CSS', label: '城堡演出团队' },
  { value: 'MSA', label: '米奇妙游童话书演出团队' },
  { value: 'TCS', label: '风暴来临演出团队' },
  { value: 'Athletic Training', label: '运动理疗培训团队' },
  { value: 'Show Ops', label: '演出运营部' },
  { value: 'ENT Campus', label: '娱乐演出校园' },
  { value: 'AoR', label: '节奏探险演出团队' },
]

export const listTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '状态',
    prop: 'status',
    width: 80,
    dicData: statusTypeOptions
  }, {
    label: '培训预览',
    prop: 'name',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 260,
  }, {
    label: '课程报名二维码',
    prop: 'miniProgramCodeUrl',
    solt: true,
    align: 'left',
    width: 150,
  }, {
    label: '开始时间',
    prop: 'startTime',
    overHidden: true,
    align: 'left',
    width: 150,
  }, {
    label: '结束时间',
    prop: 'endTime',
    overHidden: true,
    align: 'left',
    width: 150,
  }, {
    label: '可报名总人数',
    width: 120,
    prop: 'maxEnrollmentCount',
    overHidden: true,
    align: 'left',
  }, {
    label: '报名总人数',
    width: 120,
    prop: 'enrollmentCount',
    overHidden: true,
    align: 'left',
  }, {
    label: '创建人',
    width: 160,
    prop: 'createBy',
    overHidden: true,
    align: 'left',
  }, {
    label: '创建时间',
    width: 160,
    prop: 'createTime',
    overHidden: true,
    sortable: true,
    align: 'left',
  }]
}

export const activityTypesTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '名称',
    prop: 'name',
    overHidden: true,
  }, {
    label: '创建人',
    prop: 'creatorName',
    overHidden: true,
  }, {
    label: '创建时间',
    prop: 'insertedTime',
    overHidden: true,
  }]
}

export const activityProjectsTableOption = {
  page:false,
  border: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  labelWidth: '16%',
  menuWidth: 200,
  column: [ {
    label: '项目名称',
    prop: 'name',
    width: 160,
    overHidden: true,
  }, {
    label: '项目名称（英文）',
    prop: 'nameEn',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '项目描述',
    prop: 'description',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '项目描述（英文）',
    prop: 'descriptionEn',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '培训团队',
    prop: 'organizedBy',
    width: 160,
    overHidden: true,
  }, {
    label: '培训讲师',
    prop: 'lecturer',
    width: 160,
    overHidden: true,
  }, {
    label: '培训时间',
    prop: 'time',
    width: 260,
    solt: true,
    overHidden: true,
  }, {
    label: '可报名人数',
    prop: 'maxMembers',
    width: 100,
    overHidden: true,
  }, {
    label: '报名人数',
    prop: 'enrollmentCount',
    solt: true,
    width: 100,
    overHidden: true,
  }, {
    label: '报名成功人数',
    prop: 'enrollmentSuccessCount',
    solt: true,
    width: 100,
    overHidden: true,
  }, {
    label: '签到次数',
    prop: 'checkInTimes',
    solt: true,
    overHidden: true,
  }, {
    label: '签到小程序二维码',
    prop: 'checkinMiniProgramCodeUrl',
    solt: true,
    width: 140,
    overHidden: true,
  }, {
    label: '关联问卷',
    prop: 'relatedQuestionnaireId',
    solt: true,
    overHidden: true,
  }]
}

export const supportQueueActivityProjectsTableOption = {
  page:false,
  border: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  labelWidth: '16%',
  menuWidth: 200,
  column: [ {
    label: '项目名称',
    prop: 'name',
    width: 160,
    overHidden: true,
  }, {
    label: '项目名称（英文）',
    prop: 'nameEn',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '项目描述',
    prop: 'description',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '项目描述（英文）',
    prop: 'descriptionEn',
    width: 160,
    overHidden: true,
    hide: true,
  }, {
    label: '培训团队',
    prop: 'organizedBy',
    width: 160,
    overHidden: true,
  }, {
    label: '培训讲师',
    prop: 'lecturer',
    width: 160,
    overHidden: true,
  }, {
    label: '培训时间',
    prop: 'time',
    width: 260,
    solt: true,
    overHidden: true,
  }, {
    label: '可报名人数',
    prop: 'maxMembers',
    width: 100,
    overHidden: true,
  }, {
    label: '报名人数',
    prop: 'enrollmentCount',
    solt: true,
    width: 100,
    overHidden: true,
  }, {
    label: '报名成功人数',
    prop: 'enrollmentSuccessCount',
    solt: true,
    width: 100,
    overHidden: true,
  }, {
    label: '排队人数',
    prop: 'queuingEnrollmentsCount',
    width: 100,
    overHidden: true,
  }, {
    label: '签到次数',
    prop: 'checkInTimes',
    solt: true,
    overHidden: true,
  }, {
    label: '签到小程序二维码',
    prop: 'checkinMiniProgramCodeUrl',
    solt: true,
    width: 140,
    overHidden: true,
  }, {
    label: '关联问卷',
    prop: 'relatedQuestionnaireId',
    solt: true,
    overHidden: true,
  }]
}

export const activityPendingEnrollmentListTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  selection: true,
  reserveSelection: true,
  tip: false,
  menuWidth: 120,
  column: [{
    label: '员工号',
    prop: 'unionId',
    width: 120,
    overHidden: true,
  }, {
    label: '手机号',
    prop: 'phoneNumber',
    width: 140,
    overHidden: true,
    solt: true,
  }, {
    label: 'Birth Name',
    prop: 'realname',
    width: 160,
  }, {
    label: 'Full Name',
    prop: 'nickName',
    width: 160,
  }, {
    label: 'Position Name',
    width: 180,
    prop: 'position',
    overHidden: true,
  }, {
    label: 'Organizational Unit Name',
    width: 200,
    prop: 'organizationalUnitName',
    overHidden: true,
  }, {
    label: '报名时间',
    prop: 'insertedTime',
    width: 160,
    overHidden: true,
    sortable: true,
  }, {
    label: '项目组名称',
    prop: 'activityGroupName',
    width: 120,
    overHidden: true,
  }, {
    label: '子项目名称',
    prop: 'activityProjectName',
    width: 120,
    overHidden: true,
  }, {
    label: '报名状态',
    prop: 'enrollStatus',
    width: 120,
    overHidden: true,
    dicData: pendingStatusOptions
  }]
}

export const activityApprovedEnrollmentListTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  selection: true,
  reserveSelection: true,
  tip: false,
  menuWidth: 120,
  column: [{
    label: '员工号',
    prop: 'unionId',
    width: 120,
    overHidden: true,
  }, {
    label: '手机号',
    prop: 'phoneNumber',
    width: 140,
    overHidden: true,
    solt: true,
  }, {
    label: 'Birth Name',
    prop: 'realname',
    width: 160,
  }, {
    label: 'Full Name',
    prop: 'nickName',
    width: 160,
  }, {
    label: 'Position Name',
    width: 180,
    prop: 'position',
    overHidden: true,
  }, {
    label: 'Organizational Unit Name',
    width: 200,
    prop: 'organizationalUnitName',
    overHidden: true,
  }, {
    label: '报名时间',
    prop: 'insertedTime',
    width: 160,
    overHidden: true,
    sortable: true,
  }, {
    label: '项目组名称',
    prop: 'activityGroupName',
    width: 120,
    overHidden: true,
  }, {
    label: '子项目名称',
    prop: 'activityProjectName',
    width: 120,
    overHidden: true
  }, {
    label: '报名状态',
    prop: 'enrollStatus',
    width: 120,
    overHidden: true,
    dicData: employeeApplyStatusTypeOptions
  }, {
    label: '审核状态',
    prop: 'auditStatus',
    width: 120,
    overHidden: true,
    dicData: approveStatusOptions
  }, {
    label: '签到次数',
    prop: 'checkin',
    overHidden: true,
    solt: true,
  }]
}

export const categoryOptions = [
  '专业技能特长类课程',
  '外聘专业技术人才分享会',
  '领导力分享会',
  '跨部门分享课程',
  '休闲娱乐类课程',
].map(item => ({ label: item, value: item }))

export const blackStatusOptions =  [
  {
    label: '冻结中',
    value: 1
  },
  {
    label: '已解冻',
    value: 2
  }
]

export const blacklistTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [
  {
    label: '员工号',
    prop: 'unionId',
    width: 160,
    span: 24,
    fixed: 'left',
  },   
  {
    label: 'Birth Name',
    prop: 'realname',
    width: 160,
    span: 24,
    fixed: 'left',
  },        
  {
    label: 'Full Name',
    prop: 'nickname',
    width: 160,
    span: 24,
    fixed: 'left',
  },
  {
    label: '手机号',
    prop: 'phoneNumber',
    width: 160,
    solt: true,
    span: 24,
  },
  {
    label: 'Position Name',
    width: 160,
    prop: 'position',
    span: 24,
  },
  {
    label: 'Organizational Unit Name',
    width: 260,
    prop: 'organizationalUnitName',
    span: 24,
  },
  {
    label: '冻结开始时间',
    prop: 'startTime',
    overHidden: true,
    width: 130,
    type: 'date',
    format: 'yyyy-MM-dd',
    sortable: true,
  },
  {
    label: '冻结结束时间',
    prop: 'endTime',
    overHidden: true,
    width: 130,
    type: 'date',
    format: 'yyyy-MM-dd',
    sortable: true,
  },
  {
    label: '状态',
    prop: 'status',
    overHidden: true,
    width: 130,
    dicData: blackStatusOptions,
    sortable: true,
  },
  {
    label: '报名未签到子项目名称',
    prop: 'projects',
    overHidden: true,
    width: 360,
    solt: true,
  }]
}

export const blacklistProjectTableOption = {
  page: false,
  border: true,
  stripe: true,
  align: 'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  tip: false,
  menu: false,
  indexFixed: true,
  columnBtn: false,
  selection: true,
  column: [
  {
    label: '培训课程名称',
    prop: 'activityName',
    span: 24,
  },   
  {
    label: '项目组名称',
    prop: 'projectGroupName',
    span: 24,
  },        
  {
    label: '子项目名称',
    prop: 'projectName',
    span: 24,
  },
  {
    label: '子项目开始时间',
    prop: 'projectStartTime',
    overHidden: true,
    type: 'date',
    format: 'yyyy-MM-dd',
    sortable: true,
  },
  {
    label: '子项目结束时间',
    prop: 'projectEndTime',
    overHidden: true,
    type: 'date',
    format: 'yyyy-MM-dd',
    sortable: true,
  }]
}